import script from "./EmailView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailView.vue?vue&type=script&setup=true&lang=js"

import "./EmailView.vue?vue&type=style&index=0&id=f5c56560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5c56560"]])

export default __exports__